import axios from '@/utils/request';

export default {
  loginRequest(user) {
    return axios({ url: '/api/v1/auth/loginByPassword', data: user, method: 'POST' });
  },
  logoutRequest() {
    return axios({
      url: '/api/v1/auth/logout',
      method: 'POST',
    });
  },
  getVerificationCode(data) {
    return axios({
      url: '/api/v1/auth/verificationCode/get',
      method: 'post',
      data: data
    });
  },
  validateVerificationCode(data) {
    return axios({
      url: '/api/v1/auth/verificationCode/validate',
      method: 'post',
      data: data
    });
  }
};
